const getDomainName = () => window.location.hostname;

export { getDomainName };
